import { IReportMediaOptions } from "../types/reportsInterfaces";

export const createItemsArray = (data: IReportMediaOptions[], titleKey?: string) => {
  return (data || []).map((elem: IReportMediaOptions) => ({
    src: elem?.url?.link,
    ...(titleKey && { title: titleKey.split('.').reduce((acc: any, key: string) => acc[key], elem)  }),
  }));
};
